import React from 'react';
import styles from './SGSCardFooter.module.scss';
import { CardActions } from '@material-ui/core';
import classnames from 'classnames';

type Props = {
    color?: 'default' | 'info' | 'success' | 'warning' | 'danger' | 'primary' | 'secondary' | 'dark';
    children: React.ReactNode;
    className?: string;
};

const SGSCardFooter: React.FC<Props> = ({ color = 'default', className, children }) => {
    return (
        <CardActions className={classnames(styles['card-footer'], styles['card-footer-' + color], className)}>
            {children}
        </CardActions>
    );
};

export default SGSCardFooter;
